__turbopack_context__.v({
  "backdrop": "Modal-module__kvaILa__backdrop",
  "backdropHitArea": "Modal-module__kvaILa__backdropHitArea",
  "closeButton": "Modal-module__kvaILa__closeButton",
  "container": "Modal-module__kvaILa__container",
  "content": "Modal-module__kvaILa__content",
  "footer": "Modal-module__kvaILa__footer",
  "header": "Modal-module__kvaILa__header",
});
